const personalData = {
  name: "IGNACIO ROCHA",
  title: "Desarrollador de Software",
  phone: "(54) 1172312162",
  email: "rochaignaciojose@gmail.com",
  location: "San Miguel, Buenos Aires",
  github: "github.com/ignacio-Jose-Rocha",
  linkedin: "linkedin.com/in/ignacio-rocha",
  about: "Desarrollador full-stack apasionado por crear soluciones tecnológicas innovadoras."
};

export default personalData;